/*
	A simple class for displaying file information and progress
	Note: This is a demonstration only and not part of SWFUpload.
	Note: Some have had problems adapting this class in IE7. It may not be suitable for your application.
*/

// Constructor
// file is a SWFUpload file object
// targetID is the HTML element id attribute that the FileProgress HTML structure will be added to.
// Instantiating a new FileProgress object with an existing file will reuse/update the existing DOM elements

import {SWFUploaderInstance, SWFUploadFile} from "./swfuploader";
import {mapClass, mapNonNull} from "../utils";

export class FileProgress {
	public fileProgressID: string;
	public opacity: number;
	public height: number;
	public fileProgressWrapper: HTMLElement | null;
	public fileProgressElement: HTMLElement;

	constructor(file: SWFUploadFile, targetID: string) {
		this.fileProgressID = file.id;

		this.opacity = 100;
		this.height = 0;

		this.fileProgressWrapper = document.getElementById(this.fileProgressID);
		if (!this.fileProgressWrapper || !(this.fileProgressWrapper.firstChild instanceof HTMLElement)) {
			this.fileProgressWrapper = document.createElement("div");
			this.fileProgressWrapper.className = "progressWrapper";
			this.fileProgressWrapper.id = this.fileProgressID;

			this.fileProgressElement = document.createElement("div");
			this.fileProgressElement.className = "progressContainer";

			const progressCancel = document.createElement("a");
			progressCancel.className = "progressCancel";
			progressCancel.href = "#";
			progressCancel.style.visibility = "hidden";
			progressCancel.appendChild(document.createTextNode(" "));

			const progressText = document.createElement("div");
			progressText.className = "progressName";
			progressText.appendChild(document.createTextNode(file.name));

			const progressBar = document.createElement("div");
			progressBar.className = "progressBarInProgress";

			const progressStatus = document.createElement("div");
			progressStatus.className = "progressBarStatus";
			progressStatus.innerHTML = "&nbsp;";

			this.fileProgressElement.appendChild(progressCancel);
			this.fileProgressElement.appendChild(progressText);
			this.fileProgressElement.appendChild(progressStatus);
			this.fileProgressElement.appendChild(progressBar);

			this.fileProgressWrapper.appendChild(this.fileProgressElement);

			mapNonNull(document.getElementById(targetID), e => this.fileProgressWrapper && e.appendChild(this.fileProgressWrapper))
		} else {
			this.fileProgressElement = this.fileProgressWrapper.firstChild;
		}

		this.height = this.fileProgressWrapper.offsetHeight;
	}

	setProgress(percentage: number) {
		this.fileProgressElement.className = "progressContainer greenprogress";
		mapClass(this.fileProgressElement.childNodes[3], HTMLElement, e => {e.className = "progressBarInProgress"; e.style.width = percentage + "%"})
	}

	setComplete() {
		this.fileProgressElement.className = "progressContainer blueprogress";
		mapClass( this.fileProgressElement.childNodes[3], HTMLElement, e => {e.className = "progressBarComplete"; e.style.width = ""})

		setTimeout(() => this.disappear(), 10000);
	}

	setError() {
		this.fileProgressElement.className = "progressContainer redprogress";
		mapClass( this.fileProgressElement.childNodes[3], HTMLElement, e => {e.className = "progressBarError"; e.style.width = "";})

		setTimeout(() => this.disappear(), 5000);
	}

	setCancelled() {
		this.fileProgressElement.className = "progressContainer";
		mapClass(this.fileProgressElement.childNodes[3], HTMLElement, e => {e.className = "progressBarError"; e.style.width = ""})

		setTimeout(() => this.disappear(), 2000);
	}

	setStatus(status: string) {
		mapClass(this.fileProgressElement.childNodes[2], HTMLElement, e => e.innerText = status)
	}

	toggleCancel(show: boolean, swfUploadInstance?: SWFUploaderInstance) {
		mapClass( this.fileProgressElement.childNodes[0], HTMLElement, e => {
			e.style.visibility = show ? "visible" : "hidden"
			if (swfUploadInstance) {
				const fileID = this.fileProgressID;
				e.onclick = function () {
					swfUploadInstance.cancelUpload(fileID);
					return false;
				};
			}
		})
	}

	disappear() {

		const reduceOpacityBy = 15;
		const reduceHeightBy = 4;
		const rate = 30;	// 15 fps

		const fileProgressWrapper: any = this.fileProgressWrapper;
		if (this.opacity > 0) {
			this.opacity -= reduceOpacityBy;
			if (this.opacity < 0) {
				this.opacity = 0;
			}

			if (fileProgressWrapper) {
				if (fileProgressWrapper.filters) {
					try {
						fileProgressWrapper.filters.item("DXImageTransform.Microsoft.Alpha").opacity = this.opacity;
					} catch (e) {
						// If it is not set initially, the browser will throw an error.  This will set it if it is not set yet.
						fileProgressWrapper.style.filter = "progid:DXImageTransform.Microsoft.Alpha(opacity=" + this.opacity + ")";
					}
				} else {
					fileProgressWrapper.style.opacity = (this.opacity / 100).toString();
				}
			}
		}

		if (this.height > 0) {
			this.height -= reduceHeightBy;
			if (this.height < 0) {
				this.height = 0;
			}

			fileProgressWrapper.style.height = this.height + "px";
		}

		if (this.height > 0 || this.opacity > 0) {
			setTimeout(() => this.disappear() , rate);
		} else {
			fileProgressWrapper.style.display = "none";
		}
	}
}



// WEBPACK FOOTER //
// ./src/lib/swfuploader/fileprogress.ts